<template>
  <div>
    <div v-for="section in Object.keys(items)" class="section-container">
      <h2>{{ section }}</h2>

      <ul>
        <li v-for="item in items[section]">
          <a href="#" @click.prevent="viewDocument(item)"><i aria-hidden="true" class="fa fa-external-link"></i> {{ item.title }}</a>
        </li>
      </ul>
    </div>

    <portal to="blank">
      <modal name="acknowledge" :is-opaque="true">
        <h3>{{ current_item.title }}</h3>
        <div class="company-document-outer-container">
          <header>
            <img src="/img/logo-header-inverted.png" style="width:150px">
            <div>
              <div>Document Ref : {{ current_item.reference }}</div>
              <div>Version : {{ current_item.version }}</div>
            </div>
          </header>

          <template v-if="current_item.document">
            <div class="company-document-container" v-html="current_item.document.body">

            </div>
          </template>
        </div>


        <div class="actions">
          <a href="#" @click.prevent="closeModal()">Cancel</a>
          <a href="#" class="success" @click.prevent="acknowledgeDocument(current_item)">Acknowledge Document As Read &amp; Understood</a>
        </div>
      </modal>
    </portal>

  </div>
</template>

<script>

export default {
  props: ['documentsUrl','finishedUrl'],
  data() {
    return {
      items: [],
      current_item:{}
    }
  },
  watch: {},
  filters: {},
  computed: {},
  methods: {
    viewDocument(document){
      this.current_item = document;
      eventBus.$emit('modal-open-acknowledge', function (closure) {
        that.openModal();
      });
    },
    closeModal(){
      this.current_item = {};
      eventBus.$emit('modal-close-acknowledge');
      window.setTimeout(function(){
        $(window).scrollTop(0);
      },100);
    },
    acknowledgeDocument(document){
      var that = this;
      axios.request({
        method: document._links.acknowledge.method,
        url: document._links.acknowledge.url,
        data: {}
      }).then(response => {
        that.getDocuments(false);
        that.closeModal();

      });
    },
    getDocuments() {
      var that = this;
      var url = this.documentsUrl;
      var params = {
        filter: "unacknowledged"
      };


      axios.get(url, {params: params})
          .then(response => {

            if(_.isEmpty(response.data.data))
            {
              window.location.replace(that.finishedUrl);
            }

            let items = _.sortBy(response.data.data, [function (item) {
              return item.title;
            }]);

            that.items = _.groupBy(items, 'section');

          });

    }
  },
  mounted() {
    this.getDocuments();
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 2em;
  text-align: center;
  display: block;
  margin: 0 auto 1em auto;
  color: $brand;
  font-weight: 400;
}

h2 {
  font-size: 1.5em;
  text-align: center;
  display: block;
  margin: 0 auto 1em auto;
  color: #FFF;
  font-weight: 400;
}

ul {
  text-align: left;
}

ul li a {
  color: #FFF;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.2em;
  margin-bottom: 1em;
  display:block;

  &:hover {
    color: #B4D5FF;
  }

  i {
    margin-right: 0.5em;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.section-container {
  background-color: $brand;
  padding: 1em;
  margin-bottom: 1em;
  border-radius: $standardBorderRadius;
}
.company-document-container {
  background-color: #FFF;
  border-radius: $standardBorderRadius;

  @include resetListStyling();

  text-align:left;

  textarea, .ck-editor {
    background-color: #FFF !important;
  }
}

.company-document-outer-container {
  @include clearfix();
  margin: 2em;
  padding:2em;
  border-radius: $standardBorderRadius;
  border: 3px solid #cedbe1;
  header{
    margin-bottom:2em;
    @include clearfix();
  }
  header img {
    float: left;
  }

  header > div {
    float: right;

    div {
      text-align: right;
    }
  }
}

</style>
